import { useSetRecoilState } from 'recoil';
import { verifyStatusAtom, mailStatusAtom } from '_state/signature';
import axios from 'utils/api'; // default import from api.js

export default function useUserActions() {
  const setVerifyStatus = useSetRecoilState(verifyStatusAtom);
  const setMailStatus = useSetRecoilState(mailStatusAtom);

  return {
    verifyUser,
    sendMail,
  };

  async function verifyUser(payload) {
    try {
      const { data, status } = await axios({
        method: 'post',
        // url: '/api/v1/signature/save/',
        url: '/prospect',
        data: payload,
      });

      setVerifyStatus({ data, status, payload });
    } catch (error) {
      const { data, status } = error.response;
      setVerifyStatus({ data, status, payload });
    }
  }

  async function sendMail(payload) {
    try {
      const { data, status } = await axios({
        method: 'post',
        url: '/api/v1/signature/mail/',
        data: payload,
      });

      setMailStatus({ data, status, payload });
    } catch (error) {
      const { data, status } = error.response;
      setMailStatus({ data, status, payload });
    }
  }
}
